// src/utils/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    // Affichez un spinner pendant que l'état d'authentification est vérifié
    // Vous pouvez utiliser vos composants LoadingContainer/LoadingBar ici
    return <div>Vérification de l'authentification...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;